import {API} from "aws-amplify";

export async function fetchResults(body) {
  const params = { body };
  return API.post('RecognitionAPI', '/IDEMIADataRecoveryService', params);
}
